module.exports = __webpack_public_path__ + "img/imoa.25c93620.png";